import isFunction from "lodash/isFunction";
import isEmpty from "lodash/isEmpty";
import { callApi } from "../../wea-tools/callApi";
import { orgInfoArr } from "./propType";

// 获取数据
export function getData(params) {
  this.setState({ loading: true });
  const { dataURL, type, onError, isSingle, topPrefix } = this.props;
  const { current: cu, pageSize, companyId: cpid, activeKey } = this.state;
  const current = params.current || cu;
  let newState = {};
  if (orgInfoArr.indexOf(type + "") !== -1) {
    const companyId = params.virtualCompanyid || cpid || "1";
    newState = { ...newState, companyId: companyId };
    params["virtualCompanyid"] = companyId;
  }
  if (this.isCrm()) {
    const companyId = params.virtualtype || cpid || "1";
    newState = { ...newState, companyId: companyId };
    params["virtualtype"] = companyId;
  }
  callApi(`${dataURL}${type}`, "GET", {
    pageSize,
    current,
    min: (current - 1) * pageSize + 1,
    max: current * pageSize,
    ...params
  })
    .then(res => {
      const { datas, columns, companys } = res;
      let contentType = res.type;
      // 人力资源浏览框
      if (this.isCrm()) {
        // 人力浏览框数据处理
        if (activeKey == "4") {
          // 人力树
          contentType = 6;
        } else if (activeKey == "5") {
          // 人力常用组
          contentType = 7;
        } else if (["1", "2", "3"].indexOf(activeKey) !== -1) {
          // 人力列表
          contentType = 5;
        } else if (activeKey == "") {
          // 搜索结果
          contentType = 5;
        }
      }
      // browser data type
      if (typeof contentType === "number") {
        newState = { ...newState, contentType };
        // list or table with dataKey & pagination
        if (contentType === 1) {
          // table session key
          if (datas) {
            newState.dataKey = datas;
            if (!isSingle) {
              this.getDataOfListWithkey({
                dataKey: datas,
                current,
                pageSize
              });
            }
          }
        } else {
          newState = {
            ...newState,
            ...this.getRowNameKeyFromColumns(columns)
          };
        }
        // list or table without pagination & dataKey
        // type === 2
        if (contentType === 2) {
          newState = {
            ...newState,
            dataOfListWithoutKeyAndPg: { datas, columns },
            columns
          };
        }
        // type === 3
        // tree
        if (contentType === 3) {
          let defaultExpandedKeys = [];
          let treeDatas = datas;
          if (datas && datas.id) {
            // defaultExpandedKeys.push(datas.id);
            defaultExpandedKeys.push(`${topPrefix}0-${datas.id}`);
            treeDatas = [treeDatas];
          }
          newState = {
            ...newState,
            treeDatas,
            defaultExpandedKeys,
            loadAllTreeData: res.isLoadAll
          };
          if (!isEmpty(companys)) {
            const companyList = companys.map(c => ({
              ...c,
              label: c.name,
              value: c.companyid
            }));
            newState = {
              ...newState,
              companyList,
              companyId: companys[0].companyid
            };
          } else if (typeof companys === "undefined") {
            newState.companyList = undefined;
          }
        }
        // list or table with pagination without dataKey
        // type === 4
        if (contentType === 4) {
          newState = {
            ...newState,
            columns,
            dataOfListWithoutKeyButPg: { datas, columns, count: res.total },
            count: res.total,
            current
          };
        }
        // 人力列表
        if (contentType === 5) {
          datas.forEach(item => {
            item.icon = item.messagerurl;
            item.nodeid = `resource_${item.id}x`;
            item.type = "resource";
          });
          newState = {
            ...newState,
            ...this.getRowNameKeyFromColumns(columns),
            columns,
            current,
            dataOfListWithoutKeyButPg: { datas },
            count: res.count
          };
        }
        // 人力组织树
        if (contentType === 6) {
          const defaultExpandedKeys = [];
          if (datas && datas.isParent) {
            datas.isParent = "true";
            datas.open = "true";
            datas.canClick = "false";
          }
          if (datas && datas.id) {
            // defaultExpandedKeys.push(datas.id);
            defaultExpandedKeys.push(`${topPrefix}0-${datas.id}`);
          }
          newState = {
            ...newState,
            treeDatas: datas,
            defaultExpandedKeys
          };
        }
        // 人力常用组
        if (contentType === 7) {
          this.getGroupTreeDatas(datas);
          const defaultExpandedKeys = [];
          if (datas && datas.isParent) {
            datas.isParent = "true";
            datas.open = "true";
          }
          if (datas && datas.id) {
            defaultExpandedKeys.push(`${topPrefix}0-${datas.id}`);
            // defaultExpandedKeys.push(datas.id);
          }
          newState = {
            ...newState,
            groupTreeDatas: datas,
            defaultExpandedKeys,
            hasRight: res.hasRight || 0
          };
        }
      }
      this.setState(newState, () => this.setState({ loading: false }));
    })
    .catch(e => isFunction(onError) && onError(e));
}

// 获取type=1的列表的数据
export function getDataOfListWithkey(params) {
  const { current: c, pageSize, dataKey: dk } = this.state;
  const { onError } = this.props;
  const current = params.current || c;
  const dataKey = params.dataKey || dk;
  callApi("/api/ec/dev/table/datas", "POST", {
    ...params,
    pageSize,
    current,
    dataKey,
    min: (current - 1) * pageSize + 1,
    max: current * pageSize
  })
    .then(res => {
      let newState = {
        loading: false,
        current,
        dataKey
      };
      if (res && res.datas) {
        const { datas, columns } = res;
        newState = {
          ...newState,
          columns,
          dataOfListWithkey: datas,
          ...this.getRowNameKeyFromColumns(columns)
        };
      }
      this.setState(newState);
    })
    .catch(e => isFunction(onError) && onError(e));
  callApi("/api/ec/dev/table/counts", "POST", {
    dataKey
  })
    .then(res => {
      this.setState({
        count: res.count
      });
    })
    .catch(e => isFunction(onError) && onError(e));
}

// 根据columns获取显示列
export function getRowNameKeyFromColumns(cols) {
  let { inputId, inputName } = this.state;
  const inputTop = [];
  const inputBottom = [];
  if (Array.isArray(cols)) {
    cols.forEach(col => {
      if (col.isPrimarykey === "true") {
        inputId = col.dbField || col.dataIndex;
      }
      if (col.isInputCol === "true") {
        inputName = col.dbField || col.dataIndex;
      }
      if (col.hide === "false") {
        if (col.showType === "1") {
          inputTop.push(col.dbField || col.dataIndex);
        }
        if (col.showType === "0") {
          inputBottom.push(col.dbField || col.dataIndex);
        }
      }
    });
  }
  return {
    inputId,
    inputName,
    inputTop,
    inputBottom
  };
}

// 调用已选数据接口
export function callSelectedReq(_params, data, needGetExtraParams) {
  const { destUrl, dataParams, destDataParams, type } = this.props;
  let url = `${destUrl}${type}`;
  let method = "GET";
  let params = { ...(this.isCrm() ? dataParams : destDataParams), ..._params };
  if (this.isCrm()) {
    url = `/api/public/browser/data/${type}`;
    method = "POST";
    needGetExtraParams = true;
  }
  if (orgInfoArr.findIndex(t => t == type) > 0) {
    method = "POST";
    needGetExtraParams = true;
  }
  if (needGetExtraParams) params = { ...this.getExtraParams(data), ...params };
  return callApi(url, method, params);
}

// 获取已选数据
export function getSelectedData(v) {
  const { needCallDest, isMultCheckbox } = this.props;
  const { inputId } = this.state;
  const data = v || this.getDataOfProps() || [];
  const params = {};
  let selectedData = data;
  params.selectids = data.map(d => d[inputId] || d.id || "");
  if (!isEmpty(data) && needCallDest && !isMultCheckbox) {
    this.callSelectedReq(params, data).then(res => {
      if (!isEmpty(res)) {
        let { datas } = res;
        if (this.isCrm()) datas = this.formatData(datas);
        selectedData = (datas || []).filter(d => d[inputId] || d.id);
      }
      this.setState({ selectedData });
    });
  } else {
    this.setState({ selectedData });
  }
}

// 获取人力资源维度列表
export function getVirtual() {
  const {
    virtualUrl = "/api/public/browser/data/1?cmd=companyvirtual"
  } = this.props;
  callApi(virtualUrl, "GET").then(data => {
    let companysDefault = 0;
    const datas = data.datas.map(item => {
      if (item.id == 0) companysDefault = item.virtualtype;
      return { ...item, companyid: item.id, name: item.virtualtype };
    });
    this.setState({
      companyId: companysDefault, //获取行政组织
      companyList: datas
    });
  });
  // this.getResourceTree(0);
  // this.getGrouptree();
}
// 获取左侧树数据
export function getLeftTreeDatas(params, curData, callback) {
  const { leftTreeUrl, leftTreeParams, type, conditionDataParams } = this.props;
  callApi(`${leftTreeUrl}${type}`, "GET", {
    ...conditionDataParams,
    ...leftTreeParams,
    ...params
  }).then(res => {
    let datas = res.datas || [];
    if (curData) {
      // 请求下一级
      const { leftTreeDatas } = this.state;
      datas = this.refreshTreeDatas(leftTreeDatas, curData.key, datas);
    }
    this.setState({ leftTreeDatas: datas });
    if (callback) callback();
  });
}



// WEBPACK FOOTER //
// ./ecology9/wea-browser-test/browser/getData.js